import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import TextButton from "../designSystem/buttons/TextButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import Accordion from "../designSystem/Accordion";
import FindAMortage1 from "../../assets/images/mortgage_whychooseus.png";
import FindAMortage2 from "../../assets/images/mortgage_firsttimebuyers.png";
import FindAMortage3 from "../../assets/images/mortgage_buytolet.png";
import FindAMortage4 from "../../assets/images/mortgage_remortgage.png";
import FindAMortage5 from "../../assets/images/mortgage_homemovers.png";
import { ReactComponent as One } from "../../assets/icons/1.svg";
import { ReactComponent as Two } from "../../assets/icons/2.svg";
import { ReactComponent as Three } from "../../assets/icons/3.svg";
import { ReactComponent as Four } from "../../assets/icons/4.svg";
import { ReactComponent as Five } from "../../assets/icons/5.svg";
import { ReactComponent as Six } from "../../assets/icons/6.svg";
import { ReactComponent as Seven } from "../../assets/icons/7.svg";
import { ReactComponent as Eight } from "../../assets/icons/8.svg";

const FindAMortgage = () => {
  return (
    <div>
      <SEO
        title="Find a Mortgage"
        description="Explore mortgage advice for first-time buyers, home movers, remortgages and buy-to-let investors with clear support from AK Mortgages."
        path="/find-a-mortgage"
      />
      <Hero
        title={`Mortgage advice tailored to you`}
        subtitle="Find a mortgage"
        titleAlign="center"
        subtitleAlign="center"
      >
        <div className="column-center gap-s">
          <div className="content text-primary-1">
            Finding the right mortgage can feel overwhelming, especially with so
            many lenders, products and rates available. At AK Mortgages, we take
            the stress out of the process by providing clear, honest advice
            tailored to your individual circumstances.
          </div>
          <div className="content text-primary-1">
            Whether you're buying your first home, moving house, remortgaging or
            investing in property, we'll guide you through every step and help
            you secure a mortgage that supports your goals.
          </div>
        </div>
      </Hero>
      <div className="background-container bg-white">
        <div className="content-container row-center grid2 gap-xxxxxl row-center">
          <img
            src={FindAMortage1}
            alt="AK Mortgages adviser helping clients compare mortgage options"
            className="hero-image"
          />
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              why choose us?
            </div>
            <h2 className="text-primary-1 uppercase">
              Why work with AK Mortgages
            </h2>
            <div className="content text-primary-1">
              <ul className="content text-primary-1 column gap-m">
                <li>Step by step support through your mortgage journey</li>
                <li>Friendly, honest and ethical service</li>
                <li>Access to whole of market products</li>
                <li>Clear expectations without the jargon</li>
                <li>Advice from an experienced adviser</li>
              </ul>
            </div>
            <PrimaryButton text="Contact Us" />
            <div className="body2 text-primary-1">
              Your home may be repossessed if you do not keep up with repayments
              on your mortgage.
            </div>
          </div>
        </div>
      </div>
      <div id="first-time-buyers" className="background-container bg-gray-3">
        <div className="content-container row-reverse gap-xxxxxl">
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              First time buyers
            </div>
            <h3 className="text-primary-1 uppercase">
              taking your first step onto the property ladder
            </h3>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Buying your first home is exciting, but it can also feel
                overwhelming. From understanding how much you can borrow to
                navigating surveys, solicitors and mortgage applications,
                there's a lot to consider.
              </div>
              <div className="content text-primary-1">
                We'll help simplify the process, explain everything clearly, and
                support you from your initial enquiry right through to
                collecting the keys to your new home.
              </div>
              <div className="content text-primary-1">
                Buying your first home doesn't have to be daunting. We're here
                to make it straightforward and stress-free. We can help with:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>Mortgage affordability assessments</li>
                  <li>Deposit and lending options</li>
                  <li>Government schemes where applicable</li>
                  <li>Agreement in Principle applications</li>
                  <li>Full mortgage applications</li>
                  <li>Protection recommendations</li>
                </ul>
              </div>
            </div>
            <div className="row-flex-start gap-s">
              <PrimaryButton text="Book a free initial appointment" />
              <TertiaryButton text="Read FAQs" />
            </div>
          </div>{" "}
          <img
            src={FindAMortage2}
            alt="First-time buyer receiving mortgage guidance"
            className="hero-image"
          />
        </div>
      </div>

      <div id="buy-to-let-mortgages" className="background-container">
        <div className="content-container row gap-xxxxxl">
          <img
            src={FindAMortage3}
            alt="Buy-to-let mortgage advice for property investors"
            className="hero-image"
          />
          <div className="column gap-l">
            <div className="column gap-s">
              <div className="subtitle-semibold  text-primary-2 uppercase">
                buy-to-let mortgages
              </div>
              <h3 className="text-primary-1 uppercase">
                mortgage solutions for property investors
              </h3>
            </div>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Whether you're purchasing your first rental property or
                expanding an established portfolio, specialist mortgage advice
                can make a significant difference.
              </div>
              <div className="content text-primary-1">
                Buy-to-let mortgages often involve different criteria and
                considerations than residential mortgages. We help landlords
                understand their options and navigate lender requirements with
                confidence. We provide advice for:
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>First-time landlords</li>
                  <li>Portfolio landlords</li>
                  <li>Limited company buy-to-let purchases</li>
                  <li>Remortgaging investment properties</li>
                  <li>Property portfolio expansion</li>
                  <li>Reviewing existing landlord arrangements</li>
                </ul>
              </div>
              <div className="content text-primary-1">
                Our goal is to help you find a mortgage solution that supports
                your investment strategy both now and in the future.
              </div>
            </div>
            <div className="row-flex-start gap-s">
              <PrimaryButton text="Book a free initial appointment" />
              <TertiaryButton text="Read FAQs" />
            </div>
            <div className="body2 text-primary-1">
              The Financial Conduct Authority does not regulate most buy-to-let
              mortgages. Your home may be repossessed if you do not keep up with
              repayments on your mortgage.
            </div>
          </div>
        </div>
      </div>
      <div id="remortgage" className="background-container bg-gray-3">
        <div className="content-container row-reverse gap-xxxxxl">
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              REMORTGAGE
            </div>
            <h3 className="text-primary-1 uppercase">
              REVIEW YOUR MORTGAGE. EXPLORE YOUR OPTIONS.
            </h3>
            <div className="column gap-m">
              <div className="content text-primary-1">
                Whether your current mortgage deal is coming to an end or you're
                looking to make better use of your property's value, reviewing
                your mortgage could help you secure a more suitable solution.
              </div>
              <div className="content text-primary-1">
                We'll help simplify the process, explain everything clearly, and
                support you from your initial enquiry right through to
                collecting the keys to your new home.
              </div>
              <div className="content text-primary-1">
                Whether your current mortgage deal is coming to an end or you're
                looking to make better use of your property's value, reviewing
                your mortgage could help you secure a more suitable solution.
              </div>
              <div className="content text-primary-1">
                <ul className="content text-primary-1 column gap-m">
                  <li>Switching to a new mortgage deal</li>
                  <li>Releasing equity from your property</li>
                  <li>Home improvements and renovations</li>
                  <li>Fixed and variable rate options</li>
                  <li>Reviewing existing mortgage arrangements</li>
                </ul>
              </div>
            </div>
            <div className="content text-primary-1">
              Our goal is to help you find a remortgage solution that meets your
              current needs while supporting your long-term financial plans.
            </div>
            <div className="row-flex-start gap-s">
              <PrimaryButton text="Book a free initial appointment" />
              <TertiaryButton text="Read FAQs" />
            </div>
          </div>{" "}
          <img
            src={FindAMortage4}
            alt="Remortgage advice meeting"
            className="hero-image"
          />
        </div>
      </div>
      <div id="home-movers" className="background-container bg-primary-1">
        <div className="content-container row gap-xxxxxl">
          <img
            src={FindAMortage5}
            alt="Home mover planning a new mortgage"
            className="hero-image"
          />
          <div className="column gap-l">
            <div className="column gap-s">
              <div className="subtitle-semibold  text-primary-2 uppercase">
                home movers
              </div>
              <h3 className="text-white uppercase">
                moving home? let’s find the right mortgage
              </h3>
            </div>
            <div className="column gap-m">
              <div className="content text-white">
                A new home often means new opportunities, but it may also mean
                reviewing your existing mortgage arrangements.
              </div>
              <div className="content text-white">
                Whether you're upsizing, downsizing, relocating for work, or
                moving closer to family, we'll help you understand your options
                and ensure your mortgage moves with you in the most suitable way
                possible. We can help you:
              </div>
              <div className="content text-white">
                <ul className="content text-white column gap-m">
                  <li>Understand your borrowing potential</li>
                  <li>Assess whether to port your mortgage</li>
                  <li>Explore new mortgage products</li>
                  <li>Changing affordability requirements</li>
                  <li>Manage the mortgage application process</li>
                </ul>
              </div>
              <div className="content text-white">
                Moving home is a major life event. We'll help ensure your
                mortgage journey is as seamless as possible. At AK Mortgages,
                all like-for-like remortgage and product transfer applications
                are provided free of charge.
              </div>
            </div>
            <div className="row-flex-start gap-s">
              <PrimaryButton text="Book a free initial appointment" />
              <SecondaryButton text="Read FAQs" />
            </div>
          </div>
        </div>
      </div>
      <div className="background-container">
        <div className="content-container column gap-xxxl">
          <h3 className="text-primary-1 uppercase">
            moving home? let’s find the right mortgage
          </h3>
          <div className="column gap-xl">
            <div className="row-flex row gap-xl">
              <div className="row-flex gap-xl">
                <One />
                <div className="column gap-xs">
                  <div className="subtitle-semibold  text-primary-1 uppercase">
                    Initial Consultation
                  </div>
                  <div className="content text-primary-1">
                    We’ll discuss your circumstances, goals, and mortgage
                    requirements.
                  </div>
                </div>
              </div>
              <div className="row-flex  gap-xl">
                <Two />
                <div className="column gap-xs">
                  <div className="subtitle-semibold  text-primary-1 uppercase">
                    Affordability Assessment
                  </div>
                  <div className="content text-primary-1">
                    We'll provide maximum lending figures and monthly payment
                    illustrations based on your borrowing requirements.
                  </div>
                </div>
              </div>
            </div>
            <div className="row-flex row gap-xl">
              <div className="row-flex gap-xl">
                <Three />
                <div className="column gap-xs">
                  <div className="subtitle-semibold  text-primary-1 uppercase">
                    Decision in Principle
                  </div>
                  <div className="content text-primary-1">
                    We’ll secure a Decision in Principle so you’re in a position
                    to view properties and make offers.
                  </div>
                </div>
              </div>
              <div className="row-flex gap-xl">
                <Four />
                <div className="column gap-xs">
                  <div className="subtitle-semibold  text-primary-1 uppercase">
                    Research & Recommendations
                  </div>
                  <div className="content text-primary-1">
                    We'll research suitable mortgage options and explain our
                    recommendations, while introducing trusted professionals to
                    support your purchase.
                  </div>
                </div>
              </div>
            </div>
            <div className="row-flex row gap-xl">
              <div className="row-flex gap-xl">
                <Five />
                <div className="column gap-xs">
                  <div className="subtitle-semibold  text-primary-1 uppercase">
                    Application Support
                  </div>
                  <div className="content text-primary-1">
                    We’ll manage the full mortgage application process and
                    liaise with lenders on your behalf.
                  </div>
                </div>
              </div>
              <div className="row-flex gap-xl">
                <Six />
                <div className="column gap-xs">
                  <div className="subtitle-semibold  text-primary-1 uppercase">
                    Mortgage & Progress Updates
                  </div>
                  <div className="content text-primary-1">
                    We'll keep you updated from application to mortgage offer
                    and answer any questions along the way.
                  </div>
                </div>
              </div>
            </div>
            <div className="row-flex row gap-xl">
              <div className="row-flex gap-xl">
                <Seven />
                <div className="column gap-xs">
                  <div className="subtitle-semibold  text-primary-1 uppercase">
                    Rate Monitoring
                  </div>
                  <div className="content text-primary-1">
                    We'll monitor rates and notify you of reductions, helping
                    you secure a better deal before completion.
                  </div>
                </div>
              </div>
              <div className="row-flex gap-xl">
                <Eight />
                <div className="column gap-xs">
                  <div className="subtitle-semibold  text-primary-1 uppercase">
                    Completion
                  </div>
                  <div className="content text-primary-1">
                    Once everything is finalised, you can focus on your next
                    chapter with confidence.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1">
        <div className="content-container column gap-l">
          <div className="column gap-m">
            <div className="subtitle-semibold  text-white uppercase">
              Ready to discuss your mortgage?
            </div>

            <div className="content text-white">
              Whether you're buying your first home, looking for a better
              mortgage deal, or arranging protection for your family, we're here
              to help.
            </div>
            <div className="content text-white">
              Book a free, no-obligation consultation with one of our advisers
              at AK Mortgages.
            </div>
            <PrimaryButton
              text="book a free initial appointment"
              onClick={() =>
                window.open(
                  "https://bookings.cloud.microsoft/bookwithme/user/fa2261725ab84f21bb747357792d358b%40akmortgages.uk?anonymous&ismsaljsauthenabled",
                  "_blank",
                )
              }
            />
          </div>
          <div className="body2 text-white">
            Your home may be repossessed if you do not keep up with repayments
            on your mortgage.
          </div>
        </div>
      </div>
      <div
        id="faqs"
        data-section="faqs"
        className="background-container bg-gray-3"
      >
        <div className="content-container column gap-xxl">
          <h3 className="text-primary-1 uppercase">
            frequently asked questions
          </h3>
          <div className="column gap-m">
            <div className="subtitle-semibold text-primary-1">
              FIRST TIME BUYERS
            </div>
            <Accordion
              title="Do you need a 5% deposit?"
              children={
                <div>
                  No some lenders do not need a deposit at all and some lenders
                  can use a 2% deposit. Certain criteria must be met to be
                  eligible for these products, please reach out if you wish to
                  discuss further.
                </div>
              }
            />
            <Accordion
              title="Do I need a credit card to get a mortgage?"
              children={
                <div>
                  This is a misconception that you have to have a credit card;
                  this simply isn’t true. We recommend getting your credit
                  report done and then booking in an appointment and speak with
                  us to review your report. This allows us to provide
                  recommendations if needed.
                </div>
              }
            />
            <Accordion
              title="Do lenders all use the same multiple on your income?"
              children={
                <div>
                  No, every lender has different criteria on income and the
                  multiple enhancement they will apply on your application. This
                  could be due to type of employed such as self-employment or
                  fixed term contracts, individual or combined gross income or
                  size of your deposit. We have access to the whole market,
                  please book in with us to look at your max lending potential.
                </div>
              }
            />
            <Accordion
              title="Do I need to be working for a certain amount of time?"
              children={
                <div>
                  So this depends on the type of work, Sole trader or limited
                  company directors normally require a 2 year track record,
                  however some lenders can work off just 1 year accounts if
                  needed, regarding employed roles if permanent some lenders can
                  go from day 1 employment or can use an offer letter from the
                  employer if the employment is within 3 months of starting. We
                  have a wide range of experience in all these areas, if your
                  unsure, please just book a free consultation and we can offer
                  you some professional guidance.
                </div>
              }
            />
            {/* <Accordion
              title=""
              children={<div className="content text-primary-1"></div>}
            /> */}
          </div>
          <div className="column gap-m">
            <div className="subtitle-semibold text-primary-1">BUY-TO-LET</div>
            <Accordion
              title="Can I buy a property as a first-time buyer, first time landlord?"
              children={
                <div>
                  Yes, you can do this, you will be limited to lenders you will
                  be eligible for as not many lenders accept both first time
                  buyer, first time landlord at time of application.
                </div>
              }
            />
            <Accordion
              title="Is it better to buy an investment property in a personal name or set up a special purpose vehicle?"
              children={
                <div>
                  This will all depend on a variety on circumstances, I would
                  recommend speaking to a financial adviser first, then booking
                  in an appointment so we discuss the most cost-effective
                  solution for you.
                </div>
              }
            />
            <Accordion
              title="Does the new BTL property have to be an energy rated C or above now?"
              children={
                <div>
                  No, the guidance is still that the property must have a valid
                  EPC rating of usual F and above, however some lenders will
                  provide better rates and stress testing for properties that
                  are more energy efficient. If you wish to discuss this in more
                  detail, please just book an appointment.
                </div>
              }
            />
            <Accordion
              title="What is a rental stress test?"
              children={
                <div>
                  Lenders will apply a formula ensuring the projected rent
                  exceeds the monthly interest by a set amount. This will be
                  determined by your tax threshold or if it is in a personal or
                  SPV company name. Basic and SPV will usually be stressed at
                  125% (whereas higher and additional tax thresholds will be
                  145%) at a stress rate product of around 5-5.5%. we can work
                  out your rental income needed or max lending amount on project
                  rental income for you.
                </div>
              }
            />
            <Accordion
              title="Can I remortgage a BTL property from day 1?"
              children={
                <div>
                  Yes, well most lenders will want you to have owned the
                  property for 6 months, there are lenders that can do day 1
                  remortgages if your looking to refinance a property you have
                  brought cash, maybe at auction and wanted to raise the funds
                  to buy another investment property, we can help sort these
                  lenders for you and discuss the process.
                </div>
              }
            />
          </div>
          <div className="column gap-m">
            <div className="subtitle-semibold text-primary-1">REMORTGAGE</div>
            <Accordion
              title="Is a product transfer / rate switch the same as a like for like remortgage?"
              children={
                <div>
                  No a product transfer / rate switch is a similar process which
                  often means no re-assessment from your current lender and you
                  can select your new mortgage product to kick in when your
                  current deal expires (avoiding going onto the lenders SVR
                  rate), where as a like for like remortgage normally means a
                  new application to a new lender, new documents, credit &
                  affordability assessed, new valuation on the property and
                  solicitors. Pretty much the same as a First-time buyer or
                  moving home application?
                </div>
              }
            />
            <Accordion
              title="Can I reduce the mortgage term when I remortgage to a new lender?"
              children={
                <div>
                  Yes, of course, and it would be advised to do so if your
                  current financial situation allows you to do so. Lenders will
                  reduce borrowing capacity when the mortgage term is decreased
                  due to compacting the mortgage term and payments becoming
                  higher. We can look at your options in terms of max lending,
                  mortgage term length and making sure it fits in line with
                  commitments your happy to make.
                </div>
              }
            />
            <Accordion
              title="How long does a remortgage take?"
              children={
                <div>
                  So, a remortgage application from start to completion is
                  normally quicker than a moving home or first-time buyer
                  purchase because there isn’t a chain involved. On average you
                  will be looking at 6-8 weeks to get a remortgage application
                  completed, depending on the quality of solicitors involved.
                </div>
              }
            />
            <Accordion
              title="Can I take some money out of the property when doing a remortgage?"
              children={
                <div>
                  Yes, there is 2 ways you can do this. This could be a further
                  advance with your current lender or a capital raise remortgage
                  with a new lender. Both scenarios with have certain criteria
                  to meet such as loan to value (loan amount divided by property
                  value) or the reason behind the extra funds needed such as
                  home improvements, debt consolidation. Please book a chat so
                  we can explain your full options with you.
                </div>
              }
            />
          </div>
          <div className="column gap-m">
            <div className="subtitle-semibold text-primary-1">MOVING HOME</div>
            <Accordion
              title="Will I have to pay an ERC (early repayment charge) on my current mortgage?"
              children={
                <div>
                  Not necessarily, this will all depend on the type of mortgage
                  product, the product expiry date and whether you can port your
                  current mortgage to the new property, if you’re looking at
                  moving home and you want some guidance on your current
                  mortgage situation, please book a free consultation.
                </div>
              }
            />
            <Accordion
              title="If I stay with my current lender, will I be assessed again when moving homes?"
              children={
                <div>
                  Yes, any new security address, you will be assessed on a
                  credit and affordability assessment from your current lender,
                  we can review this process for you and see if you fit with
                  your current lender, if not we have a whole market of lenders
                  that could be sensible solution for you.
                </div>
              }
            />
            <Accordion
              title="Can I reduce my mortgage term & make overpayments when moving home?"
              children={
                <div>
                  Yes, absolutely a moving home application is essential a brand
                  new application whether staying with your existing lender or
                  choosing a different lender, so you can ask to reduce your
                  mortgage term as long as it fits with the lender’s
                  affordability calculation. Overpayments are a great way of
                  paying off the capitals and reducing the interest incurred on
                  the mortgage. Most lenders offer a 10% allowance in each year
                  although there are some lenders like NatWest & Atom that have
                  a 20% overpayment facility. We would factor this into our
                  discussions with you so you can make an informed decision.
                </div>
              }
            />
          </div>
          <div className="body2 text-primary-1 text-center width-100">
            Your home may be repossessed if you do not keep up with repayments
            on your mortgage.
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindAMortgage;
